<template>
  <div id="app" class="container print-page-a4 default_font" style="padding: 0;">
    <div class="row">
      <div class="col-xs-12 text-left" style="margin-top:20px; margin-left:10%; ">
        <div v-if="projectLogo" style="display: inline-block; position: absolute; top: -10px;margin-left:-85px;">
          <img :src="projectLogo" class="resize-project-logo-lg" style="max-width: 125px;" />
        </div>
        <!-- <div style=" display: inline-block;margin-left: 30px;">
          <div class="default_font_vn" style="font-size: 14px; text-align: center">{{ getCompanyName(projectData && projectData.company_name).vi }}</div>
          <div class="default_font_en" style="font-size: 14px; text-align: center">
            <i>{{ getCompanyName(projectData && projectData.company_name).en }}</i>
          </div>
        </div> -->
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 text-center" style="margin-top:0px;">
        <div style=" display: inline-block;">
          <div class="default_font_vn" style="font-size: 16px;">{{ getCompanyName(projectData && projectData.company_name).vi }}</div>
          <div
            class="default_font_en"
            style="font-size: 16px;"
          >{{ getCompanyName(projectData && projectData.company_name).en }}</div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 text-center" style="margin-top:15px;">
        <div style=" display: inline-block;">
          <div class="default_font_vn">
            {{ onlyElectricWater ? electricTitleVN : managementTitleVN}} {{invoicedata.periodStringTitleEN}}
            {{ onlyElectricWater ? `${invoicedata.accountingPeriod.month}/${invoicedata.accountingPeriod.year}` : null }}
             <span v-if="parseInt(printInvoiceType) === 2">({{ lastReminderTitleVN }})</span>
          </div>
          <div class="default_font_en">
            {{ onlyElectricWater ? electricTitleEN : managementTitleEN}} {{invoicedata.periodStringTitleEN}}
            {{ onlyElectricWater ? `${invoicedata.accountingPeriod.month}/${invoicedata.accountingPeriod.year}` : null }}
            <span v-if="parseInt(printInvoiceType) === 2">({{ lastReminderTitleEN }})</span>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <!-- <div class="col-md-12 col-xs-12">
          <div style="float: right;">
            <div>
              <span>Phiếu số /
                <i>
                  Bill No.:
                  <b>#{{invoicedata.invoice_number}}</b>
                </i>
              </span>
            </div>
            <div>
              <div style="white-space: nowrap;">
                Số dư hiện tại
                <i>&nbsp;/ Current balance:</i>
                <i>
                  <b>{{formatPrice(this.invoicedata.liability_cash_surplus)}}</b>
                </i>
                VND
              </div>
            </div>
          </div>
        </div> -->
        <div class="col-md-12 col-xs-12">
          <div class="table-responsive" style="margin: 0">
            <table class="table table-condensed customer-info" style="border:0px solid red;margin-bottom: 5px;">
              <tbody>
                <tr>
                  <td>
                    <div style="white-space: nowrap;">
                      Thông tin Khách hàng <i>/ Customer name</i>:&nbsp;
                    </div>
                  </td>
                  <td style="width: 80%;" colspan="2">
                    <b class="text-uppercase" style="text-align:left;">
                      {{ invoicedata.receiptReceiveInfoData ? invoicedata.receiptReceiveInfoData.full_name : invoicedata.resident_fullname }}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div style="white-space: nowrap;">
                      Mã Căn - Phần Thuê <i>/ Unit No.</i>:&nbsp;
                    </div>
                  </td>
                  <td>{{invoicedata.resident_address_apartment}}</td>
                </tr>
                <tr>
                  <td>
                    <div style="white-space: nowrap;">
                      Địa chỉ liên lạc <i>/ Address</i>:&nbsp;
                    </div>
                  </td>
                  <td colspan="2">
                    {{ invoicedata.receiptReceiveInfoData ? invoicedata.receiptReceiveInfoData.address : invoicedata.resident_address }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <div style="white-space: nowrap;">
                      Số điện thoại <i>/ Tel</i>:&nbsp;
                    </div>
                  </td>
                  <td>
                    {{ invoicedata.receiptReceiveInfoData ? invoicedata.receiptReceiveInfoData.phone : invoicedata.resident_phone }}
                  </td>
                </tr>
                <tr>
                  <td>
                    Email:
                  </td>
                  <td>
                    {{ invoicedata.receiptReceiveInfoData ? invoicedata.receiptReceiveInfoData.email : invoicedata.resident_email }}
                  </td>
                </tr>

                <tr>
                  <td colspan="2">
                    Kỳ hóa đơn: {{invoicedata.invoice_description}}
                    <!-- <span style="display: block">
                      <div style="width: 150px;display: inline-block;">
                        <span>Thời hạn thanh toán:</span>
                      </div>
                      <span>Vui lòng thanh toán trước {{convertDateVN(invoicedata.due_date)}}</span>
                    </span>
                    <span class="font_italic">
                      <div style="width: 150px;display: inline-block;">
                        Payment before:
                      </div>
                      <span>Please make your payment by {{convertDateEN(invoicedata.due_date)}}</span>
                    </span> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row" style="margin-bottom: 0px;">
        <div class="col-md-12 col-xs-12">
          <b>I. Thông tin chi tiết</b> <i>/ Information details:</i>
          <span style="float: right;" class="font_italic">ĐVT: đồng</span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12">
          <table class="table table_total_fee" style="margin-bottom: 10px">
            <thead class="text-center">
              <tr class="small-item-block">
                <th class="text-center" :style="`${!onlyElectricWater ? 'display: none;' : ''}vertical-align: middle; font-size: 12px;`">
                  <b>STT</b>
                  <br />
                  <i class="table_column_en">No.</i>
                </th>
                <th class="text-center" style="vertical-align: middle; font-size: 12px;">
                  <b>Khoản mục</b>
                  <br />
                  <i class="table_column_en">Item</i>
                </th>
                <th class="text-center" :style="`${!onlyElectricWater ? 'display: none;' : ''}vertical-align: middle; font-size: 12px;`">
                  Chỉ số cũ
                  <br />
                  <i class="table_column_en">Previous Index</i>
                </th>
                <th class="text-center" :style="`${!onlyElectricWater ? 'display: none;' : ''}vertical-align: middle; font-size: 12px;`">
                  Chỉ số mới
                  <br />
                  <i class="table_column_en">Current Index</i>
                </th>
                <th class="text-center" :style="`${!onlyElectricWater ? 'display: none;' : ''}vertical-align: middle; font-size: 12px;`">
                  Tiêu thụ
                  <br />
                  <i class="table_column_en">Consumption</i>
                </th>
                <th class="text-center" :style="`${!onlyElectricWater ? 'display: none;' : ''}vertical-align: middle; font-size: 12px;`">
                  Đơn giá
                  <br />
                  <i class="table_column_en">Unit price</i>
                </th>
                <th class="text-center" :style="`${!onlyElectricWater ? 'display: none;' : ''}vertical-align: middle; font-size: 12px;`">
                  Thành tiền
                  <br />
                  <i class="table_column_en">Total</i>
                </th>
                <th class="text-center" :style="`${!onlyElectricWater ? 'display: none;' : ''}vertical-align: middle; font-size: 12px;`">
                  % Thuế GTGT
                  <br />
                  <i class="table_column_en">(%VAT)</i>
                </th>
                <th class="text-center" :style="`${!onlyElectricWater ? 'display: none;' : ''}vertical-align: middle; font-size: 12px;`">
                  Thuế GTGT
                  <br />
                  <i class="table_column_en">VAT</i>
                </th>
                <th class="text-center" :style="`${!onlyElectricWater ? 'display: none;' : ''}vertical-align: middle; font-size: 12px;`">
                  Tổng Cộng
                  <br />
                  <i class="table_column_en">Grand Total</i>
                </th>
                <th class="text-center" :style="`${onlyElectricWater ? 'display: none;' : ''}vertical-align: middle; font-size: 12px;`">
                  Diễn Giải
                  <br />
                  <i class="table_column_en">Explainnation</i>
                </th>
                <th class="text-center" :style="`${onlyElectricWater ? 'display: none;' : ''}vertical-align: middle; font-size: 12px;`">
                  Tổng Cộng
                  <br />
                  <i class="table_column_en">Grand Total</i>
                </th>
              </tr>
            </thead>
            <tbody class>
              <tr v-if="onlyElectricWater" class="small-item-block">
                <td></td>
                <td></td>
                <td style="white-space: nowrap; text-align:center; font-size: 10px;">(1)</td>
                <td style="white-space: nowrap; text-align:center; font-size: 10px;">(2)</td>
                <td style="white-space: nowrap; text-align:center; font-size: 10px;">(3) = (2) - (1)</td>
                <td style="white-space: nowrap; text-align:center; font-size: 10px;">(4)</td>
                <td style="white-space: nowrap; text-align:center; font-size: 10px;">(5) = (3) x (4)</td>
                <td style="white-space: nowrap; text-align:center; font-size: 10px;">(6)</td>
                <td style="white-space: nowrap; text-align:center; font-size: 10px;">(7) = (5) x (6)</td>
                <td style="white-space: nowrap; text-align:center; font-size: 10px;">(8) = (5) + (7)</td>
              </tr>

              <tr class="small-item-block" v-for="(entry, nindex) in itemServices" :key="entry.id" :uId="entry.id">
                <template v-if="entry.id != ''">
                  <td v-for="(key) in fields" :key="key.id"
                    :style="`${!onlyElectricWater ? (
                      key['key'] === 'consumption'||
                      key['key'] == 'this_month_value' ||
                      key['key'] == 'last_month_value' ||
                      key['key'] == 'price_unit' ||
                      key['key'] == 'total_fees' || 
                      key['key'] == 'vatAmount' ||
                      key['key'] == 'vat' ||
                      key['key'] == 'STT') ? 'display: none' : '' : key['key'] == 'description' ? 'display: none' : '' }; font-size: 12px;`"
                  >
                    <p
                      v-if="key['key'] == 'total_fees' || key['key'] == 'total_all'"
                      style="text-align:right;"
                    >{{formatPrice(entry[key["key"]])}}</p>
                    <p
                      v-else-if="(key['key'] == 'this_month_value' || key['key'] == 'last_month_value') && entry[key['key']] == 0"
                      :style="`${!onlyElectricWater ? 'display: none;' : ''}text-align:center;`"
                    >-</p>
                    <p v-else-if="key['key'] == 'service_name'" style="text-align:left;">
                      {{formatServiceName(entry[key["key"]], 0)}}
                      <i>&nbsp;/ 
                        {{onlyElectricWater ?
                          formatServiceName(entry[key["key"]], 1) : formatServiceName(entry[key["key"]], 1) + ' (1)'}}</i>
                    </p>
                    <p
                      v-else-if="key['key'] == 'consumption'"
                      :style="`${!onlyElectricWater ? 'display: none;' : ''}text-align:center;`"
                    >{{entry[key["key"]]}}</p>
                    <p v-else-if="key['key'] == 'STT'" style="text-align:center;">{{nindex + 1}}</p>
                    <p
                      v-else-if="key['key'] == 'vatAmount' || key['key'] == 'price_unit'"
                      style="text-align:right"
                    >{{formatPrice(entry[key["key"]], true)}}</p>
                    <p style="text-align: center" v-else-if="key['key'] == 'vat'">
                      {{entry[key['key']]}}%
                    </p>
                    <p v-else-if="key['key'] == 'description'">{{entry[key['key']]}}</p>
                    <p v-else style="text-align:center">{{entry[key["key"]]}}</p>
                  </td>
                </template>
              </tr>

              <tr class="small-item-block">
                <td style="background-color:#66FFFF; font-size: 13px;" :colspan="onlyElectricWater ? 9 : 2" class="text-left">
                  <b>Phí phát sinh trong kỳ</b>
                  <i>&nbsp;/ Payments for period <span style="font-weight: bold;">{{`${onlyElectricWater ? '(9)' : '(2)'}`}}</span></i>
                </td>
                <td
                  style="background-color:#66FFFF; font-size: 13px; text-align:right;font-weight:bold"
                  colspan="1"
                >{{formatPrice(sum_total)}}</td>
              </tr>

              <tr class="small-item-block">
                <td style="background-color:#66FFFF; font-size: 13px;" :colspan="onlyElectricWater ? 9 : 2" class="text-left">
                  <b>Số dư nợ kỳ trước</b>
                  <i>&nbsp;/ Previous balance <span style="font-weight: bold;">{{`${onlyElectricWater ? '(10)' : '(3)'}`}}</span></i>
                </td>
                <td
                  style="background-color:#66FFFF; font-size: 13px; text-align:right;font-weight:bold;"
                  colspan="1"
                >
                {{formatPrice(this.invoicedata.old_debt)}}</td>
              </tr>

              <tr class="small-item-block">
                <td style="background-color:#66FFFF; font-size: 13px;" :colspan="onlyElectricWater ? 9 : 2" class="text-left">
                  <b>TỔNG SỐ TIỀN PHẢI THANH TOÁN</b>
                  <i>&nbsp;/ Total amount payable <span style="font-weight: bold;">{{`${onlyElectricWater ? '(11)' : '(4)'}`}}</span> = <span style="font-weight: bold;">{{`${onlyElectricWater ? '(9)' : '(2)'}`}}</span> + <span style="font-weight: bold;">{{`${onlyElectricWater ? '(10)' : '(3)'}`}}</span></i>
                </td>
                <td
                  style="background-color:#66FFFF; font-size: 13px; text-align:right;font-weight:bold;"
                  colspan="1"
                >{{formatPrice(get_total())}}</td>
              </tr>
            </tbody>

            <tr>
              <td style="background-color:white; padding-left: 10px; font-size:13px" colspan="10">
                Bằng chữ: <b>{{readMoney(get_total(), "vi")}} ./.</b>
              </td>
            </tr>

            <tr>
              <td style="background-color:white; padding-left: 10px; font-size:13px" colspan="10">
                <i>In words: {{readMoney(get_total(), "en")}} ./.</i>
              </td>
            </tr>
            <tr v-if="onlyElectricWater">
              <td style="background-color:white; padding-left: 10px; font-size: 13px;" colspan="10">
                <p style="margin: 0">
                  Xin vui lòng thanh toán trước ngày {{ invoicedata.dateDueInvoice.date }} tháng {{ invoicedata.dateDueInvoice.month }} năm {{ invoicedata.dateDueInvoice.year }} để không bị gián đoạn đến sinh hoạt hàng ngày, sau ngày này BQL sẽ ngừng cung cấp dịch vụ điện/ nước đối với căn hộ chưa thanh toán phí.
                </p>
                <p style="margin: 0">
                  Please process the payment before {{ invoicedata.dateDueInvoice.date }} {{ invoicedata.dateDueInvoice.monthEn }} {{ invoicedata.dateDueInvoice.year }} to avoid the interruption for your living.
                </p>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div class="row" v-if="!onlyElectricWater">
        <div class="col-md-12 col-xs-12">
          <p style="margin: 0;">
            <b>Quý khách vui lòng thanh toán phí quản lý trước ngày {{ invoicedata.dateDueInvoice.date }}/{{invoicedata.dateDueInvoice.month }}/{{ invoicedata.dateDueInvoice.year }} để tiếp tục sử dụng dịch vụ. Trong trường hợp chậm thanh toán, dịch vụ cung cấp điện, nước tại căn hộ của quý khách sẽ được tạm ngừng phục vụ.</b>
          </p>
          <p style="margin: 0;">
            <b>Please pay the management fee before {{ invoicedata.dateDueInvoice.date }} {{ invoicedata.dateDueInvoice.monthEn }} {{ invoicedata.dateDueInvoice.year }} to continue the service. In case of late payment, the provide of electricity, water will be temporarily stopped.</b>
          </p>
          <p style="margin: 0">
            <b>Vui lòng liên hệ Bộ phận Chăm sóc Khách hàng nếu hóa đơn này đã được thanh toán.</b>
          </p>
          <p style="margin: 0">
            <b>Please contact our customer service if your bill has been paid.</b>
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-xs-12">
          <b>II. Hình thức thanh toán</b>
          <i>&nbsp;/ Payment method:</i>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-xs-12">
          <!-- <b>1. Tiền mặt / Cash payment: Văn phòng Ban Quản Lý Dự Án Republic Plaza từ thứ 2 đến thứ 6, từ 8 giờ đến 17 giờ</b>
          <br />
          <i>Cash payment: 'Republic Plaza Building Management Office: from Monday to Friday, 8AM to 5PM</i> -->
          <b>1. Tiền mặt</b>
          <i>&nbsp;/ Cash payment</i>:
          <span style="display: block;">Thanh toán tại sảnh Lễ tân Ban Quản Lý tòa nhà Republic Plaza/ Payment at Receptionist Republic Plaza.</span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-xs-12">
          <b>2. Chuyển khoản ngân hàng</b>
          <i>&nbsp;/ Bank transfer information:</i>:
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12">
          <b>* Số tài khoản</b>
          <i>&nbsp;/ Account no.</i>:
          <b>{{invoicedata.account_no}}</b> - {{ getBankAccountNo() }} - {{ getBankAccountDetails() }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12">
          <b>* Tên tài khoản</b>
          <i>&nbsp;/ Account name</i>:
          <b>{{invoicedata.account_name}}</b>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12">
          <div>
            <div style="display: inline-block; width: 180px;">
              <b>* Nội dung chuyển khoản:</b>
            </div>
            <span v-if="onlyElectricWater">Căn hộ {{invoicedata.resident_address_apartment}} Republic Plaza thanh toán phí điện nước tháng {{invoicedata.accountingPeriod.month}}</span>
            <span v-else>Căn hộ {{invoicedata.resident_address_apartment}} Republic Plaza thanh toán phí quản lý quý .....</span>
          </div>
          <div>
            <div style="display: inline-block; width: 180px;">
              &nbsp;&nbsp;
              <span class="font_italic">Details: </span>
            </div>
            <span v-if="onlyElectricWater" class="font_italic">Apartment no. {{invoicedata.resident_address_apartment}} Republic Plaza payment for electricity and water fee of month {{invoicedata.accountingPeriod.month}}</span>
            <span v-else class="font_italic">Apartment no. {{invoicedata.resident_address_apartment}} Republic Plaza payment for management fee of quarter ....</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div v-if="onlyElectricWater" class="col-md-12 col-xs-12">
          <b>* Trường hợp thay đổi thông tin xuất hóa đơn trong tháng, vui lòng thông báo cho Ban Quản Lý trước 03 ngày kể từ ngày nhận thông báo lần đầu tiên.</b>
          <span class="font_italic" style="display: block;">&nbsp;&nbsp; In case of changing in billing information of invoice, please notify us within 3 days from the date of first notice issued.</span>
        </div>
        <div v-else class="col-md-12 col-xs-12">
          <b>* Trường hợp thay đổi thông tin xuất hóa đơn trong tháng, vui lòng thông báo cho Ban Quản Lý trước 05 ngày kể từ ngày nhận thông báo lần đầu tiên.</b>
          <span class="font_italic" style="display: block;">&nbsp;&nbsp; Please inform us before 05 days from the date of first notice issued in case you wish to change information of invoice.</span>
        </div>
      </div>
      <div class="row">
        <!-- <div class="col-md-12 col-xs-12">
          <b>* Mọi thắc mắc xin Quý khách vui lòng liên hệ Tổng đài số {{ projectData && projectData.operator_telephone }} hoặc liên hệ với Bộ phận CSKH số {{ projectData && projectData.customer_care_phone_number }} hoặc địa chỉ email {{invoicedata.email_operator}}</b>
          <span style="display: block;" class="font_italic">&nbsp;&nbsp; If you have any questions, please call the hotline {{ projectData && projectData.operator_telephone }} or Customer Service dept: {{ projectData && projectData.customer_care_phone_number }} or email address {{invoicedata.email_operator}}</span>
        </div> -->
        <div class="col-md-12 col-xs-12">
          <b>* Mọi thắc mắc xin Quý khách vui lòng liên hệ bộ phận Chăm sóc Khách hàng qua số điện thoại {{ projectData && projectData.customer_care_phone_number }} hoặc địa chỉ email {{invoicedata.email_operator}}</b>
          <span style="display: block;" class="font_italic">&nbsp;&nbsp; If you have any questions, please contact our customer service agent by dial number {{ projectData && projectData.customer_care_phone_number }} or email address {{invoicedata.email_operator}}</span>
        </div>
      </div>

      <div class="row" style="border:0px solid red;margin-top:5px;">
        <div>
          <table class="table" style="margin: 0">
            <tbody>
              <tr>
                <td style="width: 50%; border: none;">
                </td>
                <td style="border: none; text-align: center;">
                  <div style="
                    position: relative;
                    width: fit-content;
                    margin: auto;"
                  >
                    <div style="white-space: nowrap; font-style: italic; position: relative;">{{getDateFooter(this.invoicedata.date_created)}}
                      <img
                        :src="projectData.project_stamp"
                        style="
                          max-height: 135px;
                          position: absolute;
                          top: -10px;
                          left: 0px;
                        "
                      />
                    </div>
                    <p style="font-weight: bold; white-space: nowrap;">Ban quản lý tòa nhà / Building Management</p>
                    <p style="text-align: center; font-weight: bold; margin-top:5rem; white-space: nowrap;">{{ projectData && projectData.managing_director }}</p>
                    <p>Giám đốc Điều hành / Managing Director</p>
                    <!-- <img
                      :src="projectData.project_stamp"
                      class="resize-project-logo-lg"
                      style="
                        max-height: none;
                        max-width: 250px;
                        position: absolute;
                        top: 0px;
                        left: 0px;
                      "
                    /> -->
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <lte-modal
      v-show="isModalVisible"
      @onConfirm="onConfirm"
      @close="closeModal"
      v-for="obj in objModal"
      :key="obj.id"
      :item="obj"
    ></lte-modal>

    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
    <router-view></router-view>
  </div>
</template>

<script>
import LTECoreAlert from "@/components/LTESnackBar.vue";
import { mapGetters, mapActions } from "vuex";

import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";

// https://vue-multiselect.js.org/
import "vue-multiselect/dist/vue-multiselect.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
// import Multiselect from "vue-multiselect";
import moment from "moment";
import LTEModal from "@/components/LTEModal.vue";
import utils from "@/lib/utils";
import Enum from "../../../enum/enum"
import FixedServiceEnum from "@/enum/fixedServiceEnum";

export default {
  props: ["item", "projectData", "printInvoiceType", "lastPaymentDate"],
  name: "component_invoice_template_republic",
  data() {
    return {
      electricTitleVN: "THÔNG BÁO THU PHÍ ĐIỆN, NƯỚC THÁNG",
      electricTitleEN: "ELECTRIC & WATER BILL",
      managementTitleVN: "THÔNG BÁO THU PHÍ QUẢN LÝ",
      managementTitleEN: "MANAGEMENT FEE ANNOUNCEMENT",
      lastReminderTitleVN: "NHẮC THANH TOÁN",
      lastReminderTitleEN: "LAST REMINDER",
      projectLogo: null,
      // fields for show list service Usage
      fields: [
        // {
        //   key: "service_usage_id",
        //   label: "Ref Usage ID",
        //   sortable: true,
        //   sortDirection: "desc"
        // },
        {
          key: "STT",
          label: "STT",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "service_name",
          label: "Khoản mục",
          sortable: true,
          sortDirection: "desc"
        },
        // {
        //   key: "service_code",
        //   label: "Service Code",
        //   sortable: true,
        //   class: "text-center"
        // },
        // {
        //   key: "date_from",
        //   label: "Date From",
        //   sortable: true,
        //   class: "text-center"
        // },
        // {
        //   key: "date_to",
        //   label: "Date To",
        //   sortable: true,
        //   class: "text-center"
        // },
        {
          key: "last_month_value",
          label: "Chỉ số cũ",
          sortable: true,
          class: "text-center"
        },
        {
          key: "this_month_value",
          label: "Chỉ số mới",
          sortable: true,
          class: "text-center"
        },
        {
          key: "consumption",
          label: "Tiêu thụ",
          sortable: true,
          class: "text-center"
        },
        {
          key: "price_unit",
          label: "Đơn Giá",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "total_fees",
          label: "Thành tiền ",
          sortable: true,
          class: "text-center"
        },
        {
          key: "vat",
          label: "% Thuế GTGT ",
          sortable: true,
          class: "text-center"
        },
        {
          key: "vatAmount",
          label: "VAT",
          sortable: true,
          sortDirection: "desc"
        },
        // {
        //   key: "status",
        //   label: "Status",
        //   sortable: true,
        //   class: "text-center"
        // },
        {
          key: "description",
          label: "description",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "total_all",
          label: "Tổng Cộng",
          sortable: true,
          class: "text-center"
        }
        // { key: "actions", label: "Actions", class: "text-center" }
      ],
      // data for show list service Usage
      itemServices: [],
      sum_total: 0,
      // MultiSelect Service availabe
      // optionServiceSelected: null, //[{ name: 'Javascript', code: 'js' }]
      // optionServices: [], //[{"name":"Vue.js","code":"vu"},{"name":"Javascript","code":"js"},{"name":"Open Source","code":"os"}],

      // disabledOptionServices: true,
      service_usage_list: [],

      form: {
        date_issued: new Date(),
        date_paid: new Date(),
        service: null,
        device: null,
        user: this.$route.params.id
      },
      options: {
        format: "DD/MM/YYYY"
      },
      actionType: "",

      // Customer List
      customerList: [
        {
          value: null,
          text: "Select One"
        }
      ], //[{"value":1,"text":"Loi"},{"value":2,"text":"Loc"},{"value":3,"text":"Tuan"},{"value":4,"text":"Hung"},{"value":5,"text":"Hau"}]
      customerSelected: null,
      disabledCustomerList: true,

      // Status Invoice List
      statusList: [
        {
          value: null,
          text: "Select One"
        }
      ], //[{"value":1,"text":"Issue"},{"value":2,"text":"Paid"},{"value":3,"text":"Cancelled"}]
      statusSelected: null,
      disabledStatusList: false,

      search: {
        from_date: null,
        to_date: null,
        apartment_code: ""
      },

      search_result_detail: "",
      search_result: "",

      show: false,
      invoicedata: {
        id: 0,
        invoice_number: "",
        invoice_user: null,
        invoice_status: 1, // set default is Issued
        invoice_status_name: "",
        date_issued: "",
        date_paid: "",
        other_details: "",

        mainowner_fullname: "",
        mainowner_address: "",
        mainowner_email: "",
        mainowner_country: "",
        mainowner_phone: "",
        mainowner_tax: "",

        resident_fullname: "",
        resident_address_apartment: "",
        resident_address: "",
        resident_email: "",
        resident_country: "",
        resident_phone: "",
        resident_tax: "",

        account_no: "",
        account_name: "",
        transferring_contentVN: "",
        transferring_contentEN: "",
        contact_us: "",
        date_created: new Date(),
        periodStringTitleVN: "",
        periodStringTitleEN: "",
        month: "",
        liability_cash_surplus: 0,

        total_liability_cash: 0,
        old_debt: 0,
        accountingPeriod: {
          month: 0,
          year: 0
        },
        dateDueInvoice: {
          date: '',
          month: '',
          year: '',
          monthEn: ''
        },
        invoice_description: null,
        email_operator: null,
        receiptReceiveInfoData: null,
        countSendEmail: 0
      },

      isModalVisible: false,
      objModal: [
        {
          title: "Add Configuration",
          body: "Are you sure you want to add the record?",
          buttonNo : "common.delete_modal.btnNo",
          buttonYes: "common.delete_modal.btnYes",
          styleType: "default"
        }
      ],
      FixedServiceEnum: FixedServiceEnum,
      onlyElectricWater: null
    };
  },
  watch: {
    projectData: function() {
      this.projectLogo = !utils.isNull(this.projectData) ? this.projectData.project_logo : null
    }
  },
  computed: {
    functionExample: function() {
      return "";
    },

    ...mapGetters("accountingHomeLiabilityModule", {
      search_accounting_home_liability_list:
        "SEARCH_ACCOUNTING_HOME_LIABILITY_LIST",
      search_accounting_home_liability_list_detail:
        "SEARCH_ACCOUNTING_HOME_LIABILITY_LIST_DETAIL"
    }),
    ...mapGetters([
      "INVOICE_DETAIL_DATA",
      "GET_SNACK_BAR"
    ])
  },
  methods: {
    isEmptyString: function(value) {
      return utils.isEmptyString(value)
    },
    readMoney: function(number, locale) {
      return utils.readMoney(number, locale);
    },
    closeModal() {
      this.isModalVisible = false;
    },

    ...mapActions("accountingHomeLiabilityModule", [
      "SEARCH_ACCOUNTING_HOME_LIABILITY_LIST_DETAIL",
      "SEARCH_ACCOUNTING_HOME_LIABILITY_LIST"
    ]),
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST"
    ]),

    CancelInvoiceList: function() {
      this.$router.push({
        name: "InvoiceList"
      });
    },
    onConfirm: function() {
      this.isModalVisible = false;
    },

    printInvoice: function() {
      document.getElementById("cmdCancel").style.display = "none";
      document.getElementById("cmdPrintPdf").style.display = "none";
      window.print();
      document.getElementById("cmdCancel").style.display = "";
      document.getElementById("cmdPrintPdf").style.display = "";
    },
    getDateFooter(date) {
      // Day
      let day = utils.formatSqlDate(date, null, "DD");
      // Month
      let month = utils.formatSqlDate(date, null, "MM");
      // Year
      let year = utils.formatSqlDate(date, null, "YYYY");
      return "Ngày (DD) " + day + " Tháng (MM) " + month + " năm (YYYY) " + year;
    },
    convertDateVN(date) {
      // Day
      let day = utils.formatSqlDate(date, null, "DD");
      // Month
      let month = utils.formatSqlDate(date, null, "MM");
      // Year
      let year = utils.formatSqlDate(date, null, "YYYY");
      return "ngày " + day + " tháng " + month + " năm " + year;
    },
    convertDateMonth(date) {
      // Month
      let month = utils.formatSqlDate(date, null, "MM");
      // Year
      let year = utils.formatSqlDate(date, null, "YYYY");
      return " tháng " + month + " năm " + year;
    },
    convertDateEN(date) {
      return utils.formatSqlDate(date, null, "DD MMM YYYY");
    },

    formatPrice(total_fee, isFormat = false) {
      if (total_fee != undefined) {
        total_fee = utils.makeRoundNumber(total_fee);
        let rs = total_fee.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        return rs == 0 && isFormat ? "-" : rs;
      }
    },

    formatServiceName(service_name, index) {
      let item = service_name.split("/");
      return `${item[index]}`;
    },
    formatDate(date) {
      return utils.formatSqlDate(date, null, "DD/MM/YYYY");
    },
    get_total() {
      return this.sum_total + this.invoicedata.old_debt;
      // return this.invoicedata.total_liability_cash + this.sum_total;
    },

    // Excute search
    // Author: loitt
    // Input:
    // const data = {
    //   from_date: from_date,
    //   to_date: to_date,
    //   apartment_code: this.search.apartment_code
    // };
    // Output: list result
    onSearch() {
      let from_date = moment(this.search.from_date).subtract(1, "days").format("DD/MM/YYYY hh:mm:ss"); // months
      let to_date = moment(this.search.to_date).subtract(1, "days").format("DD/MM/YYYY hh:mm:ss");

      if (utils.isNull(this.search.apartment_code)) {
        this.ON_SHOW_TOAST({
          message: this.$t(
            "report_accounting_home_liability_detail.error.apartment_code"
          ),
          styleType: "danger"
        });
        return;
      }
      const data = {
        from_date: from_date,
        to_date: to_date,
        apartment_code: this.search.apartment_code
      };
      // this.get_search_accounting_home_liability_list_detail(data)
      this.get_search_accounting_home_liability_list(data);
    },
    get_search_accounting_home_liability_list_detail(data) {
      this.isLoading = true;
      this.SEARCH_ACCOUNTING_HOME_LIABILITY_LIST_DETAIL(data)
        .then(
          function(res) {
            this.search_result_detail = res.data;
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
            // check input error
            this.ON_SHOW_TOAST({
              message: "ERROR",
              styleType: "danger"
            });
          }.bind(this)
        );
    },
    get_search_accounting_home_liability_list(data) {
      this.isLoading = true;
      this.SEARCH_ACCOUNTING_HOME_LIABILITY_LIST(data)
        .then(
          function(res) {
            if (res.data.length > 0) {
              this.search_result = res.data;
              // liability_cash_surplus = Tiền Ứng = Cuối Kỳ Có
              this.invoicedata.liability_cash_surplus = this.search_result[0].closing_trade_payable_yes_max;
              // total_liability_cash = Dư Nơ = Cuối Kỳ Nợ
              this.invoicedata.total_liability_cash = this.search_result[0].closing_trade_payable_max;
            }
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
            // check input error
            this.ON_SHOW_TOAST({
              message: "ERROR",
              styleType: "danger"
            });
          }.bind(this)
        );
    },
    getCompanyName: function(data) {
      let companyNameSplit = !utils.isEmptyString(data) ? data.split("|") : []
      let companyNameVN = utils.getCleanStringValue(companyNameSplit[0], "")
      let companyNameEN = utils.getCleanStringValue(companyNameSplit[1], "")
      return {
        vi: companyNameVN,
        en: companyNameEN
      }
    },
    getBankAccountNo: function() {
      if (this.projectData && this.projectData.projectbankaccounts[0]) {
        let bankCode = this.projectData.projectbankaccounts[0].bank_code
        return bankCode !== null ? bankCode.bank_code : ''
      }
      return ''
    },
    getBankAccountDetails: function() {
      if (this.projectData && this.projectData.projectbankaccounts[0]) {
        return this.projectData.projectbankaccounts[0].bank_other_details
      }
      return ''
    },
    getDateDueInvoiceData: function(dateDueInvoice, fromFormat) {
      if (!utils.isEmptyString(dateDueInvoice)) {
        let result = moment(dateDueInvoice, fromFormat)
        if (!utils.isEmptyString(result)) {
          return {
            date: result.format("DD"),
            month: result.format("MM"),
            year: result.format("YYYY"),
            monthEn: result.format("MMMM")
          }
        }
      }
      return {
        date: '',
        month: '',
        year: '',
        monthEn: ''
      }
    }
  },
  async mounted() {
    let invoiceType = this.$route.query.invoiceType
    if (invoiceType !== undefined) {
      this.onlyElectricWater = (invoiceType == Enum.invoiceTypeEnum.MONTHLY) ? true : false
    }

    this.search.from_date = this.item.date_created;
    this.search.to_date = this.item.date_created;
    this.search.apartment_code = this.item.apartment.apartment_code;

    // await this.onSearch();
    this.invoicedata.date_created = this.item.date_created;
    this.invoicedata.invoice_number = this.item.invoice_number;
    // this.invoicedata.invoice_user = this.item.user.id;

    if (this.item.invoice_to_company_flag) {
      // Company
      // this.invoicedata.resident_fullname =
      //     this.INVOICE_DETAIL_DATA.user.company_name + " - (C) ";
      this.invoicedata.resident_fullname = this.item.owner_apartment.company_name;
      this.invoicedata.resident_tax = this.item.owner_apartment.company_tax_code;
      this.invoicedata.resident_address_apartment = this.item.owner_apartment.company_address;
      this.invoicedata.resident_address = this.item.owner_apartment.company_address;
      this.invoicedata.resident_phone = this.item.owner_apartment.phone;
    } else {
      // Customer
      // this.invoicedata.resident_fullname =
      //     this.INVOICE_DETAIL_DATA.user.name + " - (P) ";
      this.invoicedata.resident_fullname = this.item.owner_apartment.fullname;
      this.invoicedata.resident_tax = this.item.owner_apartment.personal_tax_code;
      this.invoicedata.resident_address_apartment = this.item.apartment.apartment_code;
      this.invoicedata.resident_address = this.item.owner_apartment ? ((utils.isNull(this.item.owner_apartment.address)) ? this.item.apartment.apartment_code : this.item.owner_apartment.address) : '';
      this.invoicedata.resident_phone = this.item.owner_apartment.phone;
    }
    this.itemServices = this.item.service_usage_list;
    let initialValue = 0;
    this.sum_total = this.itemServices.reduce(function(total, currentValue) {
      return total + utils.makeRoundNumber(currentValue.total_all);
    }, initialValue);
    this.invoicedata.old_debt = this.itemServices.reduce(function(total, currentValue) {
      return total + utils.makeRoundNumber(currentValue.old_debt);
    }, initialValue);

    this.invoicedata.resident_country = this.item.owner_apartment.country_name;
    this.invoicedata.resident_email = this.item.owner_apartment.email;
    this.invoicedata.resident_phone = this.item.owner_apartment.phone;

    this.invoicedata.invoice_status = this.item.invoice_status.id;
    this.invoicedata.invoice_status_name = this.item.invoice_status.status_description;

    this.invoicedata.other_details = this.item.other_details;

    let accounting_period = utils.getCleanStringValue(this.item.accounting_period, '')
    this.invoicedata.accountingPeriod.month = utils.makeRoundNumber(accounting_period.slice(4,6))
    this.invoicedata.accountingPeriod.year = utils.makeRoundNumber(accounting_period.slice(0,4))

    if (this.item.date_issued == null) {
      this.form.date_issued = new Date();
    } else {
      this.form.date_issued = this.item.date_issued;
    }
    this.invoicedata.date_issued = utils.formatSqlDate(this.form.date_issued, null, "DD-MMM-YYYY");
    if (this.item.due_date == null) {
      this.form.due_date = "";
    } else {
      this.form.due_date = this.item.due_date;
    }

    this.invoicedata.due_date = utils.formatSqlDate(this.form.due_date, null, "DD-MMM-YYYY", "");
    if (this.item.date_paid == null) {
      this.form.date_paid = new Date();
    } else {
      this.form.date_paid = this.item.date_paid;
    }
    this.invoicedata.date_paid = utils.formatSqlDate(this.form.date_paid, null, "DD-MMM-YYYY");

    this.invoicedata.dateDueInvoice = this.getDateDueInvoiceData(this.item.date_payment_invoice, null)
    if (parseInt(this.printInvoiceType) === 2 && !utils.isNull(this.lastPaymentDate)) {
      this.invoicedata.dateDueInvoice = this.getDateDueInvoiceData(this.lastPaymentDate, "DD/MM/YYYY")
    }
    this.invoicedata.invoice_description = this.item.invoice_description
    this.invoicedata.email_operator = this.item.email_operator

    // liability_cash_surplus = Tiền Ứng = Cuối Kỳ Có
    this.invoicedata.liability_cash_surplus = this.item.liability_cash_surplus;
    // total_liability_cash = Dư Nơ = Cuối Kỳ Nợ
    this.invoicedata.total_liability_cash = this.item.total_liability_cash;

    if(this.item.banktransfer != null ){
        this.invoicedata.account_no =  this.item.banktransfer.account_no ;
        this.invoicedata.account_name = this.item.banktransfer.account_name;
        this.invoicedata.transferring_contentVN = this.item.banktransfer.transferring_content;
        this.invoicedata.transferring_contentEN = this.item.banktransfer.transferring_content;
        this.invoicedata.contact_us = this.item.banktransfer.contact_us;
    }

    this.invoicedata.contact_us = "";

    this.invoicedata.receiptReceiveInfoData = this.item.receipt_receive_info_data
    this.invoicedata.countSendEmail = this.item.count_send_email

    this.projectLogo = !utils.isNull(this.projectData) ? this.projectData.project_logo : null
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    // Multiselect,
    "lte-modal": LTEModal
  }
};
</script>

<style scoped>
.print-page-a4 {
  width: 210mm !important;
  /* height: 297mm !important; */
  margin: 10mm auto !important;
  border: 1px #D3D3D3 solid;
  border-radius: 5px !important;
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  /* font-family: 'Roboto', sans-serif !important; */
  /* line-height: 1.7 !important; */
}
.btn-label {
  position: relative;
  left: -12px;
  display: inline-block;
  padding: 6px 12px;
  background: rgba(0, 0, 0, 0.15);
  border-radius: 3px 0 0 3px;
}

.btn-labeled {
  padding-top: 0;
  padding-bottom: 0;
}

.btn {
  margin-bottom: 10px;
}

.table_total_fee {
  border: 1px solid #000000 !important;
}

.table_total_fee thead tr,
.table_total_fee thead tr th,
.table_total_fee td,
.table_total_fee th {
  border: 1px solid #000000 !important;
}

.container {
  font-family: Times New Roman, Times, serif !important;
  width: 210mm !important;
  margin: 5mm auto 0mm auto !important;
  padding-left: 2.5mm !important;
  padding-right: 7.5mm !important;
}

body {
  font-size: 12px !important;
}
.resize-project-logo-lg {
  height: auto;
  width: auto;
  max-width: 110px;
  max-height: 78px;
}
@media print {
  html, body {
    width: 210mm !important;
    height: auto;
  }
  body.print {
    width: 210mm !important;
    height: auto;
  }
  .print-page-a4 {
    margin: 0 !important;
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    /* line-height: 1.7 !important; */
  }
}
/* remove title when print */
@page {
  size: A4 portrait;
  margin: 10mm 0mm 15mm 0mm;
}

.table_column_en {
  font-style: italic;
  font-weight: 100;
}
.font_italic {
  font-style: italic;
}
tr.small-item-block td {
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 0;
  padding-bottom: 0;
  vertical-align : middle;
}
tr.small-item-block th {
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 0;
  padding-bottom: 0;
  vertical-align : middle;
}
tr.small-item-block td p {
  margin: 0
}
/* .default_font_vn {
    font-size: 15px;
    font-style: normal;
    font-weight: bold;
    text-transform: uppercase;
} */
.customer-info tbody tr td{
  border: none;
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/Invoice/component_invoice_template_republic.vue